import React from 'react';
export const KEY = {
    ESCAPE: 27,
    BACKSPACE: 8,
    TAB: 9,
    ENTER: 13,
    UP: 38,
    DOWN: 40
};
/**
 * Used for grids where we want to not lazyload the first N rows
 */ export const LAZYLOAD_ROW_START = 2;
